import React from 'react';
import { useTranslation } from 'react-i18next';
import type { BillingStatus } from '@hero/schema';
import { Badge } from '../../../ui/Badge/Badge';

export interface BillingStatusBadgeProps {
  status: BillingStatus;
}

/**
 * Sales-side analog of `InvoiceStatusBadge`. Uses its own colour map
 * because Billing has fewer states (no waiting_for_approval, etc.).
 */
export function BillingStatusBadge({ status }: BillingStatusBadgeProps) {
  const { t } = useTranslation('m-billing');
  return (
    <Badge variant="secondary" size="small" className={statusClasses[status]}>
      {t(`billing_doc.status.${status}`)}
    </Badge>
  );
}

const statusClasses: Record<BillingStatus, string> = {
  draft: 'bg-gray-100 text-gray-700',
  pending: 'bg-amber-100 text-amber-800',
  partially_paid: 'bg-blue-100 text-blue-800',
  paid: 'bg-green-100 text-green-800',
  past_due: 'bg-red-100 text-red-800',
  cancelled: 'bg-gray-200 text-gray-700',
  refunded: 'bg-violet-100 text-violet-800',
};
